import React, { Fragment } from 'react';

import { BasketErrorBoundary } from '@/features/cart/CartErrorBoundary';

import { getBaskets, getIsPaypalOnList, getOrderTypes } from '@/entities/cart';
import { OrderTile } from '@/entities/cart/components/OrderTile';

import { useAppSelector } from '@/shared/hooks/appRedux';
import { usePayPal } from '@/shared/services/paypal';

const OrdersWrapper: React.FC = () => {
  const baskets = useAppSelector(getBaskets);
  const orderTypes = useAppSelector(getOrderTypes);

  const isPaypalOnList = useAppSelector(getIsPaypalOnList);
  usePayPal({
    clientId: window.cart?.paypal_client_id,
    isLoadScript: isPaypalOnList,
  });

  if (!baskets?.length) return null;

  const isSingle = baskets?.length === 1;

  return (
    <>
      {baskets.map((basket, basketIndex, array) => (
        <Fragment key={basket.Id}>
          <BasketErrorBoundary>
            <OrderTile
              basket={basket}
              basketIndex={basketIndex}
              isSingle={isSingle}
              orderTypes={orderTypes}
              numberOfOrders={array.length}
            />
          </BasketErrorBoundary>
        </Fragment>
      ))}
    </>
  );
};
export default OrdersWrapper;
